import {
  useMutationApi,
  MutationApiOptions,
  MutationApiResult,
} from '~/libs/api-hooks/architect';

interface UseSendServerSideTrackEventProps {
  reactQueryOptions?: MutationApiOptions<
    undefined,
    SendServerSideTrackEventMutatorProps
  >;
}

interface SendServerSideTrackEventMutatorProps {
  userAnalyticsId: string;
  eventName: string;
  properties: {
    [property: string]: string | boolean | number | null;
  };
}

export const mutatorRequester = ({
  userAnalyticsId,
  eventName,
  properties,
}: SendServerSideTrackEventMutatorProps) => ({
  body: {
    userAnalyticsId,
    eventName,
    properties,
  },
});

/**
 * API Hook to send a tracking event
 * @endpoint `/private/experiments/e`
 * @service (Growth-Analytics)
 */

const useSendServerSideTrackEvent = ({
  reactQueryOptions,
}: UseSendServerSideTrackEventProps = {}): MutationApiResult<
  undefined,
  SendServerSideTrackEventMutatorProps
> => {
  const pathname = '/private/experiments/e';
  const method = 'POST';
  const mutationKey = ['private', 'experiments', 'e'];

  return useMutationApi<undefined, SendServerSideTrackEventMutatorProps>({
    pathname,
    mutationKey,
    method,
    reactQueryOptions,
    includeApiKeyWhenAvailable: false,
    sendCsrfToken: false,
    mutatorRequester,
    urlOptions: { subdomain: 'app' },
  });
};

export default useSendServerSideTrackEvent;
